import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../Styles/Register.css";
import { Form, FormGroup, Button, Spinner, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "./api";
import {
    faArrowLeft,
    faEnvelope,
    faMobile,
} from "@fortawesome/free-solid-svg-icons";
import {
    faFacebook,
    faGoogle,
    faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import img_entreprise from "../assets/Images/Logo_entreprise-removebg-preview.webp";
// import ReactCountryDropdown from "react-country-dropdown";
import { useSocialAuth } from "../../Hooks/UseSocialAuth";
import Flag from 'react-world-flags';
import AuthSwitch from "./AuthSwitch";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const Register = () => {
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirm_password, setConfirmPassword] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [modeEmail, setModeEmail] = useState(true);
    const [phone, setPhone] = useState("");
    const [errors, setErrors] = useState({});

    const handleNavigateHome = () => {
        navigate("/");
    };

    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);

    const togglePasswordVisibility1 = () => {
        setShowPassword1(!showPassword1);
    };
    const togglePasswordVisibility2 = () => {
        setShowPassword2(!showPassword2);
    };

    const { handleSocialLogin } = useSocialAuth();

    const toggleMode = () => {
        setModeEmail(!modeEmail);
        setErrors({});

        if (!modeEmail) setEmail("");
        else setPhone("");
    };


    const handleChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // Retire tout sauf les chiffres
        value = value.slice(0, 10); // Limite à 10 chiffres
        value = value.replace(/(\d{2})(?=\d)/g, "$1 "); // Ajoute un espace après chaque 2 chiffres
        setPhone(value);
        setErrors({}); // Réinitialise les erreurs à chaque modification
    };

    const EmailRegex = /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
    const PasswordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    const cleanPhone = phone.replace(/\s/g, "");

    const PREFIXES_BENIN = [
        // MTN: 
        "42", "46", "50", "51", "52", "53", "54", "56", "57", "59", "61", "62", "66", "67", "69", "90", "91", "96", "97",
        // MOOV: 
        "55", "58", "60", "63", "64", "65", "68", "94", "95", "98", "99",
        // CELTIIS
        "40", "41", "43", "44", "47",

    ];
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const newErrors = {};

        if (password !== confirm_password) {
            newErrors.confirm_password = "Les mots de passe ne correspondent pas";
        } else if (!confirm_password) {
            newErrors.confirm_password = "Confirmez le mot de passe";
        } else {
        }

        // Vérifie si vide
        if (modeEmail) {
            if (!email.trim()) {
                newErrors.email = "Veuillez entrer un email";
            } else if (!EmailRegex.test(email)) {
                newErrors.email = "L'email est invalide";
            }
        } else {
            if (!cleanPhone.trim()) {
                newErrors.phone = "Veuillez entrer un numéro de téléphone";

            } else if (!/^01\d{8}$/.test(cleanPhone)) {
                newErrors.phone = "Le numéro doit commencer par 01 et contenir 10 chiffres";

            } else {
                const prefix = cleanPhone.substring(2, 4);

                if (!PREFIXES_BENIN.includes(prefix)) {
                    newErrors.phone = `Numéro invalide`;
                }
            }
        }
        if (!password) {
            newErrors.password = "Veuillez remplir ce champ";
        } else if (!PasswordRegex.test(password)) {
            newErrors.password = "Le mot de passe doit contenir au moins 8 caractères, 1 lettre, un chiffre et un caractère spécial";
        }

        if (!isChecked) {
            newErrors.isChecked =
                "Veuillez acceptez les termes et conditions d'utilisation";
        } else {
            delete newErrors.isChecked;
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            setLoading(false);
            return;
        }
        try {
            const userInput = {
                email: modeEmail ? email : null,
                phone: !modeEmail ? cleanPhone : null,
                password: password,
                password_confirmation: confirm_password,
            };
            await API.post("/register", userInput);

            toast.success("Inscription réussie");
            navigate("/login");

        } catch (err) {

            toast.error(err.response?.data?.message || "Une erreur est survenue");

        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="register_page">
            <div className="container-fluid mt-4">
                <div className="col-md-6 col-sm-10 offset-sm-1 offset-md-3 my-5 d-flex align-items-center justify-content-center">
                    <div className="formulaire">
                        <ul
                            className="d-flex flex-row list-unstyled gap-2"
                            style={{ color: "#0066BD", cursor: "pointer" }}
                            onClick={handleNavigateHome}
                        >
                            <li>
                                <HomeOutlinedIcon /></li>
                            <li>Accueil</li>
                        </ul>
                        <div className="en-tête d-flex flex-column align-items-center">
                            <img
                                src={img_entreprise}
                                alt="Entreprise Logo"
                                style={{ height: "50px" }}
                                className="my-2"
                            />
                            <AuthSwitch />
                            <h6 className="Subtitle_register m-2">
                                Bienvenu(e) sur la page d'inscription de Nol Market. Créez votre
                                compte pour accéder à toutes les fonctionnalités
                            </h6>
                        </div>
                        <div className="formulaire-content">
                            <form
                                method="post"
                                className=" mt-3 container"
                                onSubmit={handleSubmit}
                            >
                                {/* EMAIL ou TÉLÉPHONE */}
                                {modeEmail ? (
                                    <div className={`field-group ${errors?.email ? "has-error" : ""} ${email ? "has-value" : ""}`}>
                                        <span className="field-label">Email</span>
                                        <div className="input-group">
                                            <Form.Control
                                                type="text"
                                                value={email}
                                                className="input_register"
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                            <Button variant="outline-secondary" onClick={toggleMode} title="Utiliser un numéro">
                                                <FontAwesomeIcon icon={faMobile} />
                                            </Button>
                                        </div>
                                        {errors?.email && <div className="field-error">{errors.email}</div>}
                                    </div>
                                ) : (
                                    <div className={`field-group has-prefix ${errors?.phone ? "has-error" : ""} ${phone ? "has-value" : ""}`}>
                                        <span className="field-label">Numéro de téléphone</span>
                                        <div className="input-group">
                                            <InputGroup.Text className="phone-prefix">
                                                <Flag code="BJ" style={{ width: "20px" }} />
                                                +229
                                            </InputGroup.Text>
                                            <Form.Control
                                                type="tel"
                                                // placeholder="01 XX XX XX XX"
                                                className="input_register"
                                                value={phone}
                                                onChange={handleChange}
                                                style={{ borderLeft: "none" }}
                                            />
                                            <Button variant="outline-secondary" onClick={toggleMode} title="Utiliser un email">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </Button>
                                        </div>
                                        {errors?.phone && <div className="field-error">{errors.phone}</div>}
                                    </div>
                                )}

                                {/* MOT DE PASSE */}
                                <div className={`field-group ${errors?.password ? "has-error" : ""} ${password ? "has-value" : ""}`}>
                                    <span className="field-label">Mot de passe</span>
                                    <div className="input-group">
                                        <Form.Control
                                            type={showPassword1 ? "text" : "password"}
                                            className="input_register"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <Button variant="outline-secondary" onClick={togglePasswordVisibility1}>
                                            <FontAwesomeIcon icon={showPassword1 ? faEyeSlash : faEye} />
                                        </Button>
                                    </div>
                                    {errors?.password && <div className="field-error">{errors.password}</div>}
                                </div>

                                {/* CONFIRMER MOT DE PASSE */}
                                <div className={`field-group ${errors?.confirm_password ? "has-error" : ""} ${confirm_password ? "has-value" : ""}`}>
                                    <span className="field-label">Confirmer le mot de passe</span>
                                    <div className="input-group">
                                        <Form.Control
                                            type={showPassword2 ? "text" : "password"}
                                            className="input_register"
                                            value={confirm_password}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                        />
                                        <Button variant="outline-secondary" onClick={togglePasswordVisibility2}>
                                            <FontAwesomeIcon icon={showPassword2 ? faEyeSlash : faEye} />
                                        </Button>
                                    </div>
                                    {errors?.confirm_password && <div className="field-error">{errors.confirm_password}</div>}
                                </div>
                                <FormGroup>
                                    <div className="agree container">
                                        <span style={{ hyphens: "auto" }}>
                                            <input
                                                className={`m-1 cursor-pointer ${errors?.isChecked ? "is-invalid" : ""
                                                    }`}
                                                type="checkbox"
                                                checked={isChecked} // State variable to control checked status
                                                onChange={(e) => setIsChecked(e.target.checked)}
                                            />
                                            En créant votre compte, vous acceptez nos termes et
                                            conditions d'utilisation.
                                            {errors?.isChecked && (
                                                <div className="invalid-feedback">
                                                    {errors.isChecked}
                                                </div>
                                            )}
                                        </span>
                                    </div>
                                </FormGroup>

                                <Button
                                    className="button_register w-100 text-center mt-3 mb-2"
                                    type="submit"
                                    disabled={isLoading}
                                    style={{
                                        position: "relative",
                                    }}
                                >
                                    {isLoading ? (
                                        <Spinner size="sm" animation="border" />
                                    ) : (
                                        "S'inscrire"
                                    )}
                                </Button>
                            </form>
                            <p className="link_connexion_register d-flex justify-content-center mt-2">
                                Avez-vous déjà un compte ?{" "}
                                <span style={{ fontWeight: "bold", color: "blue" }}>
                                    <Link to="/login">Connectez-vous!!</Link>
                                </span>
                            </p>
                            <div className="container">
                                <div className="row h-auto d-flex align-items-center">
                                    <hr
                                        className="col-5"
                                        style={{ color: "#FA7F1B", height: "1rem" }}
                                    ></hr>
                                    <p
                                        className=" col-2 text-center"
                                        style={{ color: "#0066BD", fontWeight: "bold" }}
                                    >
                                        OU
                                    </p>
                                    <hr
                                        className="col-5"
                                        style={{ color: "#FA7F1B", height: "1rem" }}
                                    ></hr>
                                </div>
                            </div>

                            <div className="register_reseaux_sociaux d-flex justify-content-center">
                                <div className="social social-google m-2">
                                    <FontAwesomeIcon
                                        icon={faGoogle}
                                        className=""
                                        onClick={() => handleSocialLogin("google")}
                                    />
                                </div>
                                <div className="social social-facebook m-2 d-flex align-items-center">
                                    <FontAwesomeIcon
                                        icon={faFacebook}
                                        className=""
                                        onClick={() => handleSocialLogin("facebook")}
                                    />
                                </div>
                                <div className="social social-github m-2">
                                    <FontAwesomeIcon
                                        icon={faGithub}
                                        className=""
                                        onClick={() => handleSocialLogin("github")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
